import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from '@/App'
import { reloadOnceForStaleChunk } from '@/utils/chunkReload'
import '@/styles/global.css'

// Vite fires this when a lazy chunk's preload fails — typically a tab opened
// before a deploy asking for a file the deploy removed. Reloading picks up the
// current build; `preventDefault` stops the failure surfacing as a crash.
window.addEventListener('vite:preloadError', (event) => {
  if (reloadOnceForStaleChunk()) event.preventDefault()
})

const container = document.getElementById('root')
if (!container) throw new Error('Root element #root is missing from index.html.')

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
